/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    background: '#000000',
    height: 64,
    iconColor: '#ffffff',
    width: 64
  }
}
export default theme
